export default __webpack_public_path__ + "static/media/vc.eb13509c.svg";